import Image from 'next/image'
import React from 'react'
import { imgApiUrl } from '../../../lib/constants'
import style from './DentalBanner.module.css'

const DentalSurgicalBanner = ({ banner, name, mobile_banner }) => {
	return (
		<>
			<div className={style.desktop}>
				<Image src={`${imgApiUrl?.dentalsurgical}/${banner}`} layout='responsive' width={1920} height={576} alt={name} />
			</div>
			<div className={style.mobile}>
				<Image src={`${imgApiUrl?.dentalsurgical}/${mobile_banner}`} layout='responsive' width={800} height={400} alt={name} />
			</div>
		</>
	)
}

export default DentalSurgicalBanner
